import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";
import { VirkeskopskontraktUtskriftDTO } from "../../models/utskrift/utskriftValues-models";

export class UpdateKontraktUtskriftCommand extends BasicCommand<UpdateKontraktUtskriftCommand> {
    readonly kontraktUtskrift: VirkeskopskontraktUtskriftDTO;
    readonly kontraktGuid: string;

    static readonly $type = "UpdateKontraktUtskriftCommand";
    static readonly $groupKey = "KontraktUtskrift";

    get primaryKey(): IPrimaryKey<UpdateKontraktUtskriftCommand> {
        return {
            kontraktGuid: this.kontraktGuid
        };
    }

    constructor(kontraktUtskrift: VirkeskopskontraktUtskriftDTO, kontraktGuid: string) {
        super(UpdateKontraktUtskriftCommand.$type, UpdateKontraktUtskriftCommand.$groupKey, CommandType.Replace);
        this.kontraktUtskrift = kontraktUtskrift;
        this.kontraktGuid = kontraktGuid;
    }
}
